"use client"

import { createAuthClient } from "better-auth/react"
import { passkeyClient } from "@better-auth/passkey/client"
import { twoFactorClient } from "better-auth/client/plugins"

/**
 * Browser-side Better Auth client.
 *
 * Exposes React hooks:
 *  - useSession()          — current session + user, hot-reactive
 *  - signIn.email()        — email+password
 *  - signIn.social()       — Google / Apple
 *  - signIn.passkey()      — WebAuthn login
 *  - signUp.email()
 *  - signOut()
 *  - twoFactor.*           — enable/verify/disable TOTP
 *  - passkey.*             — add/remove passkeys
 */
export const authClient = createAuthClient({
  baseURL:
    typeof window !== "undefined"
      ? window.location.origin
      : process.env.NEXT_PUBLIC_BETTER_AUTH_URL ||
        "https://adis95.vercel.app",
  plugins: [
    passkeyClient(),
    twoFactorClient({
      onTwoFactorRedirect() {
        if (typeof window !== "undefined") {
          window.location.href = "/connexion/2fa"
        }
      },
    }),
  ],
})

export const {
  signIn,
  signUp,
  signOut,
  useSession,
  getSession,
  twoFactor,
  passkey,
} = authClient

/**
 * Social providers are rendered unconditionally — the user wants to SEE
 * that Google and Apple sign-in are offered even before we have the server
 * credentials wired up. If the provider isn't configured server-side,
 * better-auth returns an error we surface to the user ("configuration
 * manquante") instead of silently hiding the button.
 */
export const SOCIAL_PROVIDERS = {
  google: true,
  apple: true,
}
